import { useWindowSize } from "@tm/utils"
import { useMemo } from "react"

type ResponsiveDimensionOptions = {
    dimension?: "width" | "height" // default: "height"
    minValue?: number // default: 400
    maxValue?: number // default: 1300
    minMultiplier?: number // default: 0.5
    maxMultiplier?: number // default: 0.7
}

/**
 * Returns a responsive value (e.g., maxHeight or maxWidth) based on the current window size
 * and a specified range and multiplier.
 */
export function useResponsiveWindowDimension(options?: ResponsiveDimensionOptions): number {
    const [width, height] = useWindowSize()

    const { dimension = "height", minValue = 400, maxValue = 1300, minMultiplier = 0.5, maxMultiplier = 0.7 } = options || {}

    const base = dimension === "width" ? width : height

    return useMemo(() => {
        const clamped = Math.min(Math.max(base, minValue), maxValue)
        const multiplier = minMultiplier + ((clamped - minValue) / (maxValue - minValue)) * (maxMultiplier - minMultiplier)

        return base * multiplier
    }, [base, minValue, maxValue, minMultiplier, maxMultiplier])
}
